import axios from "axios";

function NetworkListService() {
  return axios.get(process.env.REACT_APP_API_HOST + "/networks", {
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken")}
  })
}

export default NetworkListService;
